<div class="tab-example">
  <mat-tab-group mat-stretch-tabs animationDuration="0ms" [selectedIndex]="selected.value"
    (selectedIndexChange)="tabChanged($event)" (click)="selectedTab($event)" (keyup.enter)="selectedTab($event)"
    (keyup.space)="selectedTab($event)">
    <mat-tab label="Vendor Request Form">
      <app-vendor-request-form></app-vendor-request-form>
    </mat-tab>
    <mat-tab label="Vendor Batch Request">
      <app-vendor-batch-request></app-vendor-batch-request>
    </mat-tab>
    <mat-tab label="Vendor Search Results">
      <app-vendor-search-results></app-vendor-search-results>
    </mat-tab>
    <mat-tab label="Log Out">
    </mat-tab>
  </mat-tab-group>
</div>
